import type { TInputRadar } from '@/common/types/domains/radar';

export const WEBSITE_DOMAINS_SORTABLE_COLUMNS = [
    'domain',
    'askPrice',
    'renewal',
] as const;

export type WebsiteDomainsSortableColumnId = (typeof WEBSITE_DOMAINS_SORTABLE_COLUMNS)[number];

export type WebsiteDomainsResultsSort = {
    id: WebsiteDomainsSortableColumnId;
    order: 'asc' | 'desc';
};

export const toWebsiteDomainsResultsTableSort = (
    sort: Partial<TInputRadar>['sort'] | null | undefined,
): WebsiteDomainsResultsSort | null => {
    const field = sort?.field;
    const dir = sort?.dir ?? 'desc';

    const columnId = (() => {
        switch (field) {
            case 'price':
            case 'askPrice':
                return 'askPrice';
            case 'renewal':
            case 'domain':
                return field;
            default:
                return null;
        }
    })();

    if (!columnId) return null;
    if (!WEBSITE_DOMAINS_SORTABLE_COLUMNS.includes(columnId)) return null;

    return {
        id: columnId,
        order: dir,
    };
};
